import React from 'react';
import GlobalContextProvider from './src/context/GlobalContextProvider';

import './src/styles/global.scss';

/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

export const wrapRootElement = ({ element }) => {
    return <GlobalContextProvider>{element}</GlobalContextProvider>;
};

export const shouldUpdateScroll = ({ routerProps: { location }, getSavedScrollPosition }) => {
    const currentPosition = getSavedScrollPosition(location);
    window.scrollTo(...(currentPosition || [0, 0]));

    return false;
};

/* export const onRouteUpdate = location => {
  if (location.hash) {
    console.log(document.querySelector(`${location.hash}`))
    setTimeout(() => {
      document.querySelector(`${location.hash}`).scrollIntoView()
    }, 0)
  }
} */
